import React,{Component} from 'react';
import "./style.less"
import {NavBar, Modal, Toast} from "antd-mobile";
import QRCode from 'qrcode.react';
import connect from "react-redux/es/connect/connect";

const topImg = require('../../../common/image/top-img.png');
const ewmImg = require('../../../common/image/ewmimg.png');
let canvas = "";
let imgT = "";
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Share extends Component{
    constructor(props) {
        super(props);
        this.state={
            url:""
        }
    }
    componentDidMount() {
        console.log(this.props);
        if (this.props.userInfo.isLoggedIn) {
            this.setState({
                // url:"https://www.baidu.com"
                url:`http://region.cema99.com/inviteAdd/${this.props.userInfo.userId}`
            });
        }else{
            Toast.info("您还未登录，请登录后操作！");
            this.props.history.push('/login');
        }


    }
    canvasImg(){
        console.log(this.state.url);
        if(this.state.url !== ""){
            canvas = document.getElementById("myCanvas");
            imgT = canvas.toDataURL("image/png");
        }
    }
    render(){
        // console.log(this.state.url);
        // if(this.state.url !== ""){
        //     canvas = document.getElementById("myCanvas");
        //     imgT = canvas.toDataURL("image/png");
        // }
        return(
            <div className="share">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >推荐有礼</NavBar>
                <div className="con">
                    <img src={topImg} alt=""/>
                    <p className="look"  onClick={()=>this.props.history.push('/regulation')}>点击查看奖励规则<i className="icon iconfont icon-gengduo"></i></p>
                    <button  onClick={() => document.location = `js://share?userId=${this.props.userInfo.userId}`}>分享给朋友</button>
                    <p className="ewmText">————  二维码邀请  ————</p>
                    <p className="saomiao">扫描或长按识别二维码</p>
                    <div  className="qrcode" >
                        <QRCode size={170} value={this.state.url} id="myCanvas"  renderAs="svg" />
                        <img src={ewmImg} className="ewmImg" alt=""/>
                        {/*<img src={imgT} alt=""/>*/}
                    </div>
                    {/*<div onClick={()=>this.props.history.push(`/inviteAdd/${this.props.userInfo.userId}`)}>去分享</div>*/}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/Share/index.js